export const detectMerchant = (id) => {
    switch(id) {
        case 5:
            return '1XBET';
        case 13:
            return 'TOO ""Yellow Concept Store';
        case 7:
            return 'ТОО ""EasyBus';
        case 14:
            return 'ТОО Grin Lab';
        case 1:
            return 'Первый Тестовый Мерчант';
        case 6:
            return 'Rakkomafia';
        case 4:
            return 'Мерчант 4 Тестовый';
        default:
            return 'Неизвестный мерчант'
    }
}

export const detectBank = (id) => {
    switch(id) {
        case 1:
            return 'Народный сберегательный банк Казахстана';
        case 2:
            return 'ДБ ""Альфа-Банк';
        case 5:
            return 'АО Altyn Bank';
        case 3:
            return 'АО Kaspi Bank';
        case 4:
            return 'AsiaCredit Bank';
        case 6:
            return 'Bank RBK';
        case 7:
            return 'Capital Bank Kazakhstan';
        case 8:
            return 'First Heartland jusan Bank';
        case 9:
            return 'ForteBank';
        case 10:
            return 'Tengri Bank';
        case 11:
            return 'ATF Bank';
        case 12:
            return 'Банк Kassa Nova';
        case 13:
            return 'Банк ЦентрКредит';
        case 14:
            return 'ДБ «Банк Китая в Казахстане»';
        case 15:
            return 'ДБ «КЗИ Банк»'
        case 16:
            return 'ДБ «Национальный Банк Пакистана»';
        case 17:
            return 'ДБ АО "Банк Хоум Кредит"';
        case 18:
            return 'ДБ АО «Сбербанк России»';
        case 19:
            return 'ДО АО Банк ВТБ (Казахстан)';
        case 20:
            return 'Евразийский Банк';
        case 21:
            return 'Жилстройсбербанк Казахстана';
        case 22:
            return 'Заман-Банк';
        case 23:
            return 'Исламский Банк "Al-Hilal"';
        case 24:
            return 'Нурбанк';
        case 25:
            return 'Ситибанк Казахстан';
        case 26:
            return 'ТП Банк Китая в Алматы';
        case 27:
            return 'Шинхан Банк Казахстан';
        case 28:
            return 'АО "КАЗПОЧТА"';
        case 29:
            return 'UNDEFINED';
        default:
            return 'Неизвестный банк'
    }
}

export const detectAcquirer = (id) => {
    switch(id) {
        case 1:
            return 'Epay';
        case 2:
            return 'Alfa';
        default:
            return 'Неизвестный эквайер'
    }
}

export const detectPaymentType = (id) => {
    switch(id) {
        case 0:
            return 'Прием';
        case 1:
            return 'Выплаты';
        default:
            return 'Неизвестный тип оплаты'
    }
}

export const detectPaymentStatus = (id) => {
    switch(id) {
        case 0:
            return 'Новый';
        case 1:
            return 'Успех';
        case 2:
            return 'В процессе';
        case 3:
            return 'Авторизован';
        case 4:
            return 'Отмена';
        case 5:
            return 'Возврат';
        case 6:
            return 'Фейл';
        default:
            return 'Неизвестный статус оплаты'
    }
}

export const getActionByNum = (action) => {
    switch(action) {
        case 'group':
            return 1;
        case 'sum':
            return 2;
        case 'average':
            return 3;
        case 'count':
            return 4;
        case 'period':
            return false;
        case 'nothing':
            return 0;
        default:
            return 999;
    }
}

export const getTranslateByAction = (action) => {
    switch(action) {
        case 'count':
            return 'Подсчет';
        case 'group':
            return 'Группирование';
        case 'sum':
            return 'Суммирование';
        case 'average':
            return 'Среднее';
        case 'period':
            return 'Период';
        default:
            return 'Нет перевода';
    }
}

export const checkOptionsAndCreateNew = (options) => {
    let newOptions = { ...options };
    Object.keys(newOptions).forEach(item => {
        if(!newOptions[item]) {
            newOptions[item] = 0
        }
    })

    return newOptions
}
